<template>
    <div class="home">
        <h2>404</h2>
        <p>Siden du prøvede at besøge, findes desværre ikke</p>
    </div>
</template>

<script>
    export default {
        name: "404"
    }
</script>

<style scoped>

</style>